import { normalize } from 'normalizr'
import { apartment } from '../adapters/dobovoApartmentsSchema'
import { organization } from '../adapters/dobovoOrganizationSchema'
import * as ActionTypes from './actionTypes'

// categories actions
export const dobovo_fetchApartmentsSuccess = data => ({
    type: ActionTypes.DOBOVO_APARTMENTS_FETCH_SUCCESS,
    ...data
})

export const dobovo_fetchApartmentsFailure = error => ({
    type: ActionTypes.DOBOVO_APARTMENTS_FETCH_FAILURE,
    error
})

export const dobovo_saveApartmentsSuccess = data => ({
    type: ActionTypes.DOBOVO_APARTMENTS_SAVE_SUCCESS,
    data: normalize(data, apartment)
})

export const dobovo_saveApartmentsFailure = error => ({
    type: ActionTypes.DOBOVO_APARTMENTS_SAVE_FAILURE,
    error
})

export const dobovo_deleteApartmentSuccess = id => ({
    type: ActionTypes.DOBOVO_APARTMENTS_DELETE_SUCCESS,
    data: id
})

export const dobovo_deleteApartmentFailure = error => ({
    type: ActionTypes.DOBOVO_APARTMENTS_DELETE_FAILURE,
    error
})

export const dobovo_importApartmentsSuccess = data => ({
    type: ActionTypes.DOBOVO_APARTMENTS_IMPORT_SUCCESS,
    ...data
})

export const dobovo_importApartmentsFailure = error => ({
    type: ActionTypes.DOBOVO_APARTMENTS_IMPORT_FAILURE,
    error
})

// organizations actions
export const dobovo_fetchOrganizationsSuccess = data => ({
    type: ActionTypes.DOBOVO_ORGANIZATIONS_FETCH_SUCCESS,
    ...data
})

export const dobovo_fetchOrganizationsFailure = error => ({
    type: ActionTypes.DOBOVO_ORGANIZATIONS_FETCH_FAILURE,
    error
})

export const dobovo_saveOrganizationsSuccess = data => ({
    type: ActionTypes.DOBOVO_ORGANIZATIONS_SAVE_SUCCESS,
    data: normalize(data, organization)
})

export const dobovo_updateOrganizationsFailure = error => ({
    type: ActionTypes.DOBOVO_ORGANIZATIONS_UPDATE_FAILURE,
    error
})

export const dobovo_updateOrganizationsSuccess = data => ({
    type: ActionTypes.DOBOVO_ORGANIZATIONS_UPDATE_SUCCESS,
    data: normalize(data, organization)
})

export const dobovo_deleteOrganizationSuccess = id => ({
    type: ActionTypes.DOBOVO_ORGANIZATIONS_DELETE_SUCCESS,
    data: id
})

export const dobovo_deleteOrganizationFailure = error => ({
    type: ActionTypes.DOBOVO_ORGANIZATIONS_DELETE_FAILURE,
    error
})

export const dobovo_saveOrganizationsFailure = error => ({
    type: ActionTypes.DOBOVO_ORGANIZATIONS_SAVE_FAILURE,
    error
})

// currentOrganization actions
export const dobovo_changeCurrentOrganization = id => ({
    type: ActionTypes.DOBOVO_CURRENT_ORGANIZATION_CHANGE,
    data: id
})

// sync actions
export const dobovo_pushYearPricesRequest = () => ({
    type: ActionTypes.DOBOVO_PUSH_YEAR_PRICES_REQUEST
})
export const dobovo_pushYearPricesSuccess = () => ({
    type: ActionTypes.DOBOVO_PUSH_YEAR_PRICES_SUCCESS
})
export const dobovo_pushYearPricesFailure = () => ({
    type: ActionTypes.DOBOVO_PUSH_YEAR_PRICES_FAILURE
})

export const dobovo_pushYearRestrictionsRequest = () => ({
    type: ActionTypes.DOBOVO_PUSH_YEAR_RESTRICTIONS_REQUEST
})
export const dobovo_pushYearRestrictionsSuccess = () => ({
    type: ActionTypes.DOBOVO_PUSH_YEAR_RESTRICTIONS_SUCCESS
})
export const dobovo_pushYearRestrictionsFailure = () => ({
    type: ActionTypes.DOBOVO_PUSH_YEAR_RESTRICTIONS_FAILURE
})

export const dobovo_pushYearAvailabilityRequest = () => ({
    type: ActionTypes.DOBOVO_PUSH_YEAR_AVAILABILITY_REQUEST
})
export const dobovo_pushYearAvailabilitySuccess = () => ({
    type: ActionTypes.DOBOVO_PUSH_YEAR_AVAILABILITY_SUCCESS
})
export const dobovo_pushYearAvailabilityFailure = () => ({
    type: ActionTypes.DOBOVO_PUSH_YEAR_AVAILABILITY_FAILURE
})

export const dobovo_synchronizePropertyRequest = () => ({
    type: ActionTypes.DOBOVO_SYNCHRONIZE_PROPERTY_REQUEST
})
export const dobovo_synchronizePropertySuccess = () => ({
    type: ActionTypes.DOBOVO_SYNCHRONIZE_PROPERTY_SUCCESS
})
export const dobovo_synchronizePropertyFailure = () => ({
    type: ActionTypes.DOBOVO_SYNCHRONIZE_PROPERTY_FAILURE
})

// easyms
export const dobovo_fetchEasymsCategoriesSuccess = data => ({
    type: ActionTypes.DOBOVO_EASYMS_CATEGORIES_FETCH_SUCCESS,
    payload: { ...data }
})
export const dobovo_fetchEasymsCategoriesFailure = error => ({
    type: ActionTypes.DOBOVO_EASYMS_CATEGORIES_FETCH_FAILURE,
    payload: { error }
})
export const dobovo_fetchEasymsRatesSuccess = data => ({
    type: ActionTypes.DOBOVO_EASYMS_RATES_FETCH_SUCCESS,
    payload: { ...data }
})
export const dobovo_fetchEasymsRatesFailure = error => ({
    type: ActionTypes.DOBOVO_EASYMS_RATES_FETCH_FAILURE,
    payload: { error }
})



// WEBPACK FOOTER //
// ./src/actions/dobovoActions.js